import { render, staticRenderFns } from "./editInformationSuccess.vue?vue&type=template&id=48719ea4&scoped=true"
import script from "./editInformationSuccess.vue?vue&type=script&lang=js"
export * from "./editInformationSuccess.vue?vue&type=script&lang=js"
import style0 from "./editInformationSuccess.vue?vue&type=style&index=0&id=48719ea4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48719ea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48719ea4')) {
      api.createRecord('48719ea4', component.options)
    } else {
      api.reload('48719ea4', component.options)
    }
    module.hot.accept("./editInformationSuccess.vue?vue&type=template&id=48719ea4&scoped=true", function () {
      api.rerender('48719ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/editInformationSuccess.vue"
export default component.exports